import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import Performance from 'pages/Business/Agent/Performance';

export const performanceRoutes = <Route path={home.performance} element={<Performance />} />;
